<section [ngClass]="{'ais-red': red}" class="p-0 p-sm-3">

  <button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>

  <h2 mat-dialog-title class="text-black-50 fw-bold" i18n>Zápis predmetov</h2>

  <hr/>

  <mat-dialog-content class="mat-typography">

    <section class="switch-section">
      <div class="d-flex flex-row align-content-center justify-content-between">

        <div>
          <button mat-button class="switch text-nowrap" [ngClass]="{'active': studijnyPlan}" (click)="onStudijnyPlanClick()">
            <mat-icon>school</mat-icon>
            <span class="ms-2" i18n>Môj študijný plán</span>
            <span class="badge text-bg-secondary ms-2">{{data.studijnyPlan.skratka}}</span>
          </button>

          <button mat-button class="switch text-nowrap ms-sm-3" [ngClass]="{'active': !studijnyPlan}" (click)="switchToPonuka()">
            <mat-icon>manage_search</mat-icon>
            <span class="ms-2" i18n>Vyhľadaj predmet</span>
            <span *ngIf="pocetPredmetov" class="badge text-bg-secondary ms-2">{{pocetPredmetov}}</span>
          </button>
          <span class="float-end"><mat-spinner *ngIf="loader" diameter="20"></mat-spinner></span>
        </div>


        <div>
          <button mat-icon-button aria-label="Help"
                  #tooltip="matTooltip"  i18n-matTooltip (click)="helpVisible = !helpVisible"
                  matTooltip="Pomocou ikony pridania v ľavej časti panelov s predmetmi si príslušný predmet zapíšete do svojho zápisného listu. Pre zápis predmetu, ktorý sa nenachádza vo vašom študijnom pláne zvoľte 'Vyhľadaj predmet' a do textového poľa zadajte časť názvu alebo skratky predmetu, ktorý si chcete zapísať.">
            <mat-icon class="text-blue">help</mat-icon>
          </button>
        </div>

      </div>
    </section>

    <section *ngIf="helpVisible" class="p-2 small">
      <span i18n>Pomocou ikony pridania v ľavej časti panelov s predmetmi si príslušný predmet zapíšete do svojho zápisného listu. Pre zápis predmetu, ktorý sa nenachádza vo vašom študijnom pláne zvoľte 'Vyhľadaj predmet' a do textového poľa zadajte časť názvu alebo skratky predmetu, ktorý si chcete zapísať.</span>
    </section>

    <section class="search-section">
      <div class="d-flex flex-row align-items-center">

        <mat-icon>search</mat-icon>

        <div class="m-3 pomocny-text" *ngIf="studijnyPlan">{{data.studijnyPlan.nazov}}</div>

        <div *ngIf="!studijnyPlan" class="flex-fill">
          <mat-form-field  class="m-0 p-0 pe-3 ms-sm-3 me-sm-3 w-100">
            <mat-label i18n>Hľadaj predmet</mat-label>
            <input #searchInput matInput type="text" [(ngModel)]="value" (keyup)="getPonukaPredmetov()">
            <button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="value=''">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>

      </div>
    </section>

    <section *ngIf="studijnyPlan">

      <div class="ms-md-5 mb-5">
        <mat-slide-toggle [(ngModel)]="absolvovane"><span i18n>Zobraziť aj absolvované predmety</span></mat-slide-toggle>
      </div>

      <div *ngFor="let p of getFilteredPredmety(); let i = index;">

        <div *ngIf="i===0 || filteredPredmety[i].cast.kod !== filteredPredmety[i-1].cast.kod">
          <div class="d-flex flex-row justify-content-between text-black-50">
            <div>
              <h3>{{p.cast.popis}}</h3>
              <div *ngIf="p.cast.poznamkaPred" class="small">{{p.cast.poznamkaPred}}</div>
            </div>
            <div *ngIf="p.cast.kredit">
              <span class="text-nowrap">min. {{p.cast.kredit}} <span i18n>kreditSkratka</span></span>
            </div>
          </div>
        </div>

        <div *ngIf="i===0 || filteredPredmety[i].typ.kod !== filteredPredmety[i-1].typ.kod">
          <div class="d-flex flex-row justify-content-between fw-bold border-bottom mt-3 mt-sm-0">
            <div>
              <div *ngIf="p.typ.kod">{{p.typ.kod}} - {{p.typ.popis}}</div>
              <div *ngIf="p.typ.poznamkaPred" class="small">{{p.typ.poznamkaPred}}</div>
            </div>
            <div *ngIf="p.typ.kredit">
              <span class="text-nowrap">min. {{p.typ.kredit}} <span i18n>kreditSkratka</span></span>
            </div>
          </div>
        </div>

        <div *ngIf="i===0 || filteredPredmety[i].blok.kod !== filteredPredmety[i-1].blok.kod">
          <div class="d-flex flex-row justify-content-between fw-bold text-black-50">
            <div>
              <div><span i18n>Blok</span> {{p.blok.skratka}}. - {{p.blok.popis}}</div>
              <div *ngIf="p.blok.poznamkaPred" class="small">{{p.blok.poznamkaPred}}</div>
            </div>
            <div *ngIf="p.blok.kredit">
              <span class="text-nowrap">min. {{p.blok.kredit}} <span i18n>kreditSkratka</span></span>
            </div>
          </div>
        </div>

        <app-studijny-plan-item [predmet]="p" (saved)="saved(p)"></app-studijny-plan-item>
      </div>
    </section>

    <section *ngIf="!studijnyPlan">

      <div *ngFor="let p of filtrovanaPonukaPredmetov">
        <app-predmet-z-ponuky [predmet]="p"></app-predmet-z-ponuky>
      </div>

      <div *ngIf="truncatedSearch" class="ms-md-3">
        <span i18n>Zobrazuje sa len prvých 50 predmetov</span>&nbsp;<span i18n>z</span> {{pocetPredmetov}}<span i18n>, upresnite vyhľadávanie.</span>
      </div>

    </section>

  </mat-dialog-content>

  <hr/>

  <mat-dialog-actions class="d-flex justify-content-end">
    <button mat-stroked-button [mat-dialog-close]="true" cdkFocusInitial><span i18n>Close</span></button>
  </mat-dialog-actions>

</section>
